/**
 * The Dev wallet's slot. It only fills in development builds on a server that reports cluster "local"
 * (wallet/devWallet.ts is imported dynamically behind import.meta.env.DEV, so production bundles never contain it);
 * on mainnet and devnet it stays empty.
 */
import { create } from 'zustand';
import type { TxSigner } from '@/tx/send';

interface DevSession {
  signer: TxSigner | null;
  set: (signer: TxSigner | null) => void;
}

export const useDevSession = create<DevSession>()((set) => ({ signer: null, set: (signer) => set({ signer }) }));

/** Development builds on the local clone only. */
export const devWalletAllowed = (cluster: string) => import.meta.env.DEV && cluster === 'local';

export async function startDevWallet(cluster: string): Promise<void> {
  if (!import.meta.env.DEV || cluster !== 'local') return;
  const { loadDevWallet } = await import('./devWallet');
  useDevSession.getState().set(await loadDevWallet());
}

export const stopDevWallet = () => useDevSession.getState().set(null);
